import * as React from 'react';
import { useFormContext, type FieldPath, type FieldValues } from 'react-hook-form';
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from './Form';
import { Switch } from '@/components/ui/switch';

interface FormSwitchProps<TValues extends FieldValues> {
  name: FieldPath<TValues>;
  label?: React.ReactNode;
  description?: React.ReactNode;
  disabled?: boolean;
}

export function FormSwitch<TValues extends FieldValues>({
  name,
  label,
  description,
  disabled,
}: FormSwitchProps<TValues>) {
  const { control } = useFormContext<TValues>();
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className="flex flex-row items-center justify-between rounded-md border p-3">
          <div className="space-y-0.5 pr-4">
            {label !== undefined && <FormLabel>{label}</FormLabel>}
            {description && <FormDescription>{description}</FormDescription>}
            <FormMessage />
          </div>
          <FormControl>
            <Switch
              checked={!!field.value}
              onCheckedChange={field.onChange}
              disabled={disabled}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
}
